import { render, staticRenderFns } from "./InmueblesView.vue?vue&type=template&id=13399df0&scoped=true&"
import script from "./InmueblesView.vue?vue&type=script&lang=js&"
export * from "./InmueblesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13399df0",
  null
  
)

export default component.exports